const emailErrorCodes = {
  'server-error-while-sending-email': 'Fehler auf dem Server beim Senden der E-Mail'
};

export default emailErrorCodes;
